$(document).ready(function() {
    var elem = document.querySelector(".seccion-mensajes");
    if (elem == null) {
        return;
    }
    // var psContactos;
    // var chatElement;
    // var psChat;
    // var psReservacion;

  var intervalCargarMensajes = null
  var cargandoMensajes = false

  var vueMensajes = new Vue({
      el: elem,
      data: {
        chatsFiltros: {chat_id: null},
        authId: usuarioAuthId,
        mensajesNoLeidos: 0,
        chats: [],
        reservacion: null,
        chatSeleccionado: null,
        chatSeleccionadoIndex: -1,

        mensajes: [],

        loaderChats: false,
        loaderMensajes: false,

        enviandoMensaje: false,
        mensaje: {},
        imagenes: {},
        cargarPrevios: false,
      },
      mounted() {

        this.getChats(true)

        setInterval(() => {
          vueMensajes.getChats(false);
        }, 5000)

        // psContactos = new PerfectScrollbar(document.querySelector("#scrollContactos"), {
        //   useBothWheelAxes: true,
        //   suppressScrollX: false,
        //   suppressScrollY: false,
        // })
        //
        // chatElement = document.querySelector("#scrollChat")
        //
        // psChat = new PerfectScrollbar(chatElement, {
        //   useBothWheelAxes: true,
        //   suppressScrollX: false,
        //   suppressScrollY: false,
        // })
        //
        // psReservacion = new PerfectScrollbar(document.querySelector("#scrollReservacion"), {
        //   useBothWheelAxes: true,
        //   suppressScrollX: false,
        //   suppressScrollY: false,
        // })

        // chatElement.scrollTo(0, chatElement.scrollHeight);

        window.addEventListener('resize', function() {
          vueMensajes.checkNavSize()
        });

      },
      methods: {
        abrirImagenes(imagenes, actualIndex){
          let imagenesFancy = []
          for (let index in imagenes){
            if(actualIndex != index){
              imagenesFancy.push({
                src: imagenes[index].imagen
              })
            }

          }

          imagenesFancy.splice(0, 0, {
            src: imagenes[actualIndex].imagen
          })

          Fancybox.show(imagenesFancy, {
            loop: false
          });
        },
        removerFoto(index){
          this.imagenes[this.chatSeleccionado.id].splice(index, 1)
          this.$forceUpdate();
        },
        agregarFotos(e){
          let maxSizeBytes = 5 * 1024 * 1024
          let archivosAceptados = []
          let archivosNoAceptados = ""
          for(let i = 0; i < e.srcElement.files.length; i++){
            let file = e.srcElement.files[i]
            if (file.size > maxSizeBytes) {
              archivosNoAceptados += file.name + ", "
            }
            else{
              archivosAceptados.push({
                name: file.name,
                file: file,
                url_file: URL.createObjectURL(file)
              })
            }
          }
          if(archivosNoAceptados.length > 0){
            archivosNoAceptados = archivosNoAceptados.substring(0, archivosNoAceptados.length -2)
            swal({
              icon: "info",
              title: "Los archivos " + archivosNoAceptados + " exceden los 5mb",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          }
          if(this.imagenes[this.chatSeleccionado.id] == null){
            this.imagenes[this.chatSeleccionado.id] = []
          }
          this.imagenes[this.chatSeleccionado.id] =
            this.imagenes[this.chatSeleccionado.id].concat(archivosAceptados)
          e.srcElement.value = null
          this.$forceUpdate()
        },
        setChat(chat, index){
          this.chatSeleccionadoIndex = index;
          this.chatSeleccionado = chat;
          location.hash = "chat_" + this.chatSeleccionado.id
          this.getMensajes();

          if(intervalCargarMensajes != null){
            clearInterval(intervalCargarMensajes)
          }

          intervalCargarMensajes = setInterval(() => {
            vueMensajes.getMensajes(false, "nuevos");
          }, 5000);
          this.checkNavSize()
        },
        getChatIdHash(){
          let chatId = null
          if(location.hash.length > 0){
            let chatHash = location.hash.split("_")
            if(chatHash.length == 2){
              chatId = parseInt(chatHash[1])
              if(isNaN(chatId)){
                chatId = null
              }
            }
          }
          return chatId;
        },
        getChats(usarLoader = true){
          if(this.loaderChats){
            return;
          }
          let chatId = this.getChatIdHash()
          this.chatsFiltros.chat_id = chatId
          this.loaderChats = usarLoader
          axios
            .get('/mensajes/chats-json',{
              params: this.chatsFiltros
            })
            .then((response) => {
              vueMensajes.loaderChats = false
              if (response.data.error) {
                swal({
                  icon: "info",
                  title: respuesta.data.error,
                  button: {
                    text: "Aceptar",
                    closeModal: true,
                  },
                })
                return
              }
              vueMensajes.chats = response.data.chats;
              if(chatId != null){
                let chatIndex = response.data.chats.findIndex(item => item.id == chatId)
                if(chatIndex > -1 && (vueMensajes.chatSeleccionado == null || chatId != vueMensajes.chatSeleccionado.id)){
                  vueMensajes.setChat(response.data.chats[chatIndex], chatIndex);
                }
              }
            })
            .catch((error) => {
              ReportErrorLog(error)
              console.error(error)
              vueMensajes.loaderChats = false
              swal({
                icon: "info",
                title: "Ocurrió un error inesperado",
                button: {
                  text: "Aceptar",
                  closeModal: true,
                },
              })
            })
        },
        getMensajes(usarLoader = true, tipo = ""){
          if(this.chatSeleccionado == null || this.loaderMensajes || cargandoMensajes){
            return;
          }
          cargandoMensajes = true
          this.loaderMensajes = usarLoader

          let datos = {
            reservacion_id: vueMensajes.chatSeleccionado.id
          };

          if(tipo == "nuevos"){
            if(this.mensajes.length > 0){
              let totalMensajes = this.mensajes[this.mensajes.length -1].mensajes.length -1
              datos.ultimo_mensaje_id = this.mensajes[this.mensajes.length -1].mensajes[totalMensajes].id
            }
          }
          else if(tipo == "previos"){
            if(this.mensajes.length > 0){
              datos.primer_mensaje_id = this.mensajes[0].mensajes[0].id
            }
          }
          axios
            .get('/mensajes/mensajes-json',{
              params: datos
            })
            .then((response) => {
              vueMensajes.loaderMensajes = false
              cargandoMensajes = false
              if (response.data.error) {
                swal({
                  icon: "info",
                  title: respuesta.data.error,
                  button: {
                    text: "Aceptar",
                    closeModal: true,
                  },
                })
                return
              }
              let mensajes = response.data.mensajes;
              let mensajesGrupos = [];
              let grupo = {mensajes: []}
              for(let index in mensajes){
                let mensaje = mensajes[index];
                if(grupo.mensajes != null &&
                  grupo.mensajes.length > 0 &&
                  mensaje.cliente_envia_id == grupo.mensajes[grupo.mensajes.length - 1].cliente_envia_id){
                  grupo.mensajes.splice(0, 0, mensaje)
                }
                else{
                  if(grupo.mensajes.length > 0){
                    mensajesGrupos.splice(0, 0, grupo)
                  }
                  grupo = {mensajes: []};
                  grupo.cliente = mensaje.cliente_envia
                  grupo.mensajes = [mensaje]
                }
              }
              if(grupo.mensajes != null && grupo.mensajes.length > 0){
                mensajesGrupos.splice(0, 0,grupo)
              }

              if(tipo == "nuevos"){
                vueMensajes.mensajes = [...vueMensajes.mensajes,...mensajesGrupos];
                if(mensajesGrupos.length > 0){
                  vueMensajes.chatTo();
                }
              }
              else if(tipo == "previos"){
                vueMensajes.mensajes = [...mensajesGrupos,...vueMensajes.mensajes];
                vueMensajes.cargarPrevios = response.data.cargar_mas_mensajes
                vueMensajes.chatTo("mensajeItem_" + datos.primer_mensaje_id, false);
              }
              else{
                vueMensajes.mensajes = mensajesGrupos;
                vueMensajes.chatTo();
                vueMensajes.cargarPrevios = response.data.cargar_mas_mensajes
              }

            })
            .catch((error) => {
              ReportErrorLog(error)
              console.error(error)
              vueMensajes.loaderMensajes = false
              cargandoMensajes = false
              swal({
                icon: "info",
                title: "Ocurrió un error inesperado",
                button: {
                  text: "Aceptar",
                  closeModal: true,
                },
              })
            })
        },
        enviarMensaje(){
          let mensaje = this.mensaje[this.chatSeleccionado.id]
          let imagenes = this.imagenes[this.chatSeleccionado.id]

          if(this.enviandoMensaje){
            return
          }

          if((mensaje == null || mensaje.trim().length == 0) && imagenes.length == 0){
            return;
          }

          this.enviandoMensaje = true

          let formData = new FormData();
          formData.append("reservacion_id", this.chatSeleccionado.id)
          if(mensaje != null){
            formData.append("mensaje", mensaje)
          }
          for(let index in imagenes){
            let imagen = imagenes[index]
            formData.append("imagenes[]", imagen.file)
          }

          axios
            .post('/mensajes/enviar-mensaje',formData)
            .then((response) => {
              vueMensajes.enviandoMensaje = false
              if (response.data.error) {
                swal({
                  icon: "info",
                  title: respuesta.data.error,
                  button: {
                    text: "Aceptar",
                    closeModal: true,
                  },
                })
                return
              }

              let grupo = {cliente: response.data.mensaje.cliente_envia,
                mensajes: [response.data.mensaje]}
              if(vueMensajes.mensajes.length > 0 &&
                vueMensajes.mensajes[vueMensajes.mensajes.length -1].cliente.id ==
                grupo.cliente.id){
                vueMensajes.mensajes[vueMensajes.mensajes.length -1].mensajes.push(response.data.mensaje)
              }
              else{
                vueMensajes.mensajes.push(grupo)
              }
              vueMensajes.mensaje[vueMensajes.chatSeleccionado.id] = "";
              vueMensajes.imagenes[vueMensajes.chatSeleccionado.id] = [];

              if(vueMensajes.chatSeleccionadoIndex > -1){
                vueMensajes.chats[vueMensajes.chatSeleccionadoIndex].mensaje = response.data.mensaje;
              }

              vueMensajes.chatTo();
              vueMensajes.$forceUpdate();

            })
            .catch((error) => {
              ReportErrorLog(error)
              console.error(error)
              vueMensajes.enviandoMensaje = false
              swal({
                icon: "info",
                title: "Ocurrió un error inesperado",
                button: {
                  text: "Aceptar",
                  closeModal: true,
                },
              })
            })
        },
        getImagenChat(){
          let imagen = null;
          if(this.chatSeleccionado != null){
            if(this.chatSeleccionado.actual_cliente_id ==
              this.chatSeleccionado.cliente_id){
              imagen = this.chatSeleccionado.terraza.anfitrion.imagen_thumb
            }
            else{
              imagen = this.chatSeleccionado.cliente.imagen_thumb
            }
          }

          return imagen ?? "/assets/imagenes/ic_usuario_placeholder.png";
        },

        getNombreChat(){
          let nombre = null;
          if(this.chatSeleccionado != null){
            if(this.chatSeleccionado.actual_cliente_id ==
              this.chatSeleccionado.cliente_id){
              nombre = this.chatSeleccionado.terraza.anfitrion.nombre
            }
            else{
              nombre = this.chatSeleccionado.cliente.nombre
            }
          }

          return nombre ?? "";
        },

        chatTo(id = null, animacion = true){
          setTimeout(() => {
            const element = $("#scrollChat");
            let datos = {
              scrollTop: element.prop("scrollHeight")
            };
            if(id != null){
              datos.scrollTop = $("#" + id).offset().top
            }
            element.animate(datos, animacion ? 500 : 0);
          }, 300)

        },
        cleanChat(){
          this.chatSeleccionado = null
          location.hash = ''
          this.checkNavSize()
        },
        checkNavSize(){
          let body = document.querySelector("body")
          let nav = document.querySelector(".navegacion-responsive")

          if(body.offsetWidth <= 767){
            if(this.chatSeleccionado != null){
              nav.style.display = "none";
            }
            else{
              nav.style.display = "block";
            }
          }
          else{
            nav.style.display = null;
          }
        },
        closeReservacion(e){
          if(!e.srcElement.classList.contains("open-reserva")){
            let reservaEl = document.querySelector("#scrollReservacion");
            reservaEl.classList.remove("show-reserva");
          }
        },
        openReservacion(){
          let reservaEl = document.querySelector("#scrollReservacion");
          reservaEl.classList.add("show-reserva");
        }
      }
    });

});
